import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { appVersion } from '~/utils/constants/appVersion';

type Props = {
  loading?: boolean;
  errorMessage?: string;
  onSubmit?: (payload: { account: string; password: string }) => void;
};

const SignInComponent = (props: Props) => {
  //#region Destructuring Props
  const { loading, errorMessage, onSubmit } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Declare State
  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');
  //#endregion Declare State

  //#region Handle Function
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit && onSubmit({ account, password });
  };
  //#endregion Handle Function

  return (
    <form
      id='signInComponent'
      onSubmit={handleSubmit}
      className='flex w-full max-w-[360px] flex-col gap-5 rounded-lg border border-border bg-card p-5 shadow-lg sm:p-8'
    >
      <div>
        <h1 className='text-xl font-semibold text-foreground'>{t('auth.signIn.title')}</h1>
        <p className='mt-1 text-sm text-muted-foreground'>{t('auth.signIn.subtitle')}</p>
      </div>

      <label className='flex flex-col gap-1.5'>
        <span className='text-sm font-medium text-foreground'>{t('auth.signIn.accountLabel')}</span>
        <input
          type='text'
          placeholder={t('auth.signIn.accountPlaceholder')}
          value={account}
          onChange={(e) => setAccount(e.target.value)}
          className='rounded-md border border-border bg-input px-3 py-2 text-sm text-foreground outline-none transition focus:border-ring focus:ring-2 focus:ring-ring/30'
          required
        />
      </label>

      <label className='flex flex-col gap-1.5'>
        <span className='text-sm font-medium text-foreground'>{t('auth.signIn.passwordLabel')}</span>
        <input
          type='password'
          placeholder='••••••••'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className='rounded-md border border-border bg-input px-3 py-2 text-sm text-foreground outline-none transition focus:border-ring focus:ring-2 focus:ring-ring/30'
          required
        />
      </label>

      {errorMessage && (
        <p className='rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive'>{errorMessage}</p>
      )}

      <button
        type='submit'
        disabled={loading}
        className='mt-1 w-full rounded-md bg-primary py-2.5 text-sm font-semibold text-primary-foreground transition hover:opacity-90 disabled:opacity-60'
      >
        {loading ? t('auth.signIn.submitting') : t('auth.signIn.submit')}
      </button>
      <p className='text-center text-xs text-muted-foreground'>{appVersion}</p>
    </form>
  );
};

export default SignInComponent;
